module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/pharmacy/pharmacy.component.html
// module id = ./src/app/Pages/tasks/pharmacy/pharmacy.component.html
// module chunks = main